export default __webpack_public_path__ + "static/media/iphone-android.c3fa5baa.png";